import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { ModalGlobalStyleMixin } from './ModalGlobalStyleMixin';

/** @class PopoverGlobalStyleMixin */
/** @method */
export var PopoverGlobalStyleMixin = inlineMediaQueryMixin('modal', function (mediaProps) {
  if (mediaProps.modal) {
    return ModalGlobalStyleMixin(mediaProps);
  }
  return '';
});